import { render, staticRenderFns } from "./pendingShipmentPackages.vue?vue&type=template&id=552f2bb2&scoped=true&"
import script from "./pendingShipmentPackages.vue?vue&type=script&lang=js&"
export * from "./pendingShipmentPackages.vue?vue&type=script&lang=js&"
import style0 from "./pendingShipmentPackages.vue?vue&type=style&index=0&id=552f2bb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552f2bb2",
  null
  
)

export default component.exports